import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, useHistory, useParams } from 'react-router-dom'
import { Tabs, Tab } from '../../../molecules/Tabs'
import AdminPage from '../../admin/shared/AdminPage'
import CatalogTables from './CatalogTables'
import CatalogPipelines from './CatalogPipelines'

function CatalogHome ({ root }) {
  const { type } = useParams()
  const history = useHistory()
  const onTabChange = useCallback((tab) => {
    history.replace(`${root}/catalog/list/${tab}`)
  }, [history, root])

  useEffect(() => {
    if (!type) {
      history.replace(`${root}/catalog/list/tables`)
    }
  }, [type, root, history])

  if (!type) {
    return (
      <AdminPage />
    )
  }

  return (
    <AdminPage>
      <Tabs.Wrapper>
        <Tabs
          value={type}
          onChange={(_, tabValue) => onTabChange(tabValue)}
        >
          <Tab value='tables' label='Tables' />
          <Tab value='pipelines' label='Pipelines' />
        </Tabs>
      </Tabs.Wrapper>
      <Switch>
        <Route path={`${root}/catalog/list/tables`}>
          <CatalogTables root={root} />
        </Route>
        <Route path={`${root}/catalog/list/pipelines`}>
          <CatalogPipelines root={root} />
        </Route>
      </Switch>
    </AdminPage>
  )
}

CatalogHome.propTypes = {
  root: PropTypes.any
}

export default CatalogHome
